import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { CustomTextField } from "./CustomTextField";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { InputAdornment } from "@mui/material";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer - IBL
 * @Email : kpozos@ibl.mx
 *
 * @Description Input password (text, number)
 * @param String id: Identifier for the Input password (required)
 * @param Boolean emptyFields: Indicates if the field is empty (optional)
 * @param String value: Value to display under the Input password (required)
 * @param Boolean disabled: Enable/disable writing in the Input password (optional)
 * @param String label: Text for the label (required)
 * @param Boolean required: Input field is required (optional)
 * @param String name: Name for the Input password (optional)
 * @param String helperText: Text for the legend, displayed under the Input password (optional)
 * @param Event onChange: onChange trigger in the Input password (optional)
 * @param Event onKeyDown: onKeyDown trigger in the input field (optional)
 * @param {Number} minLength - Minimum number of characters allowed for password (optional)
 * @returns {JSX.Element}
 */

export const CustomPassword = ({
    id,
    emptyFields,
    value,
    disabled,
    label,
    required,
    name,
    helperText = '',
    onChange,
    onKeyDown,
    minLength,
    length
}) => {
    const { t } = useTranslation();
    const [passwordShown, setPasswordShown] = useState(false);
    const [isTooShort, setIsTooShort] = useState(false);

    useEffect(() => {
        if (!minLength) {
            setIsTooShort(false);
            return;
        }

        const rawValue = value?.toString() || '';
        const trimmedValue = rawValue.trim();

        if (rawValue.length > 0 && trimmedValue.length === 0) {
            setIsTooShort(true);
            return;
        }

        setIsTooShort(trimmedValue.length > 0 && trimmedValue.length < minLength);
    }, [value, minLength]);

    return (
        <>
            <CustomTextField name={name} disabled={disabled}
                type={passwordShown ? "text" : "password"}
                trans={t(label)}
                required={required}
                value={value || ""}
                onChange={onChange}
                id={id}
                length={length}
                emptyFields={emptyFields}
                isValid={!isTooShort}
                isValidText={isTooShort && t("minimum_length_is", { number: minLength })}
                noUppercase={true}
                helperText={helperText}
                InputProps={{
                    endAdornment: (<InputAdornment position='end' className={"click-icon"}>
                        {passwordShown ? <VisibilityIcon onClick={() => {
                            setPasswordShown(!passwordShown)
                        }} /> : <VisibilityOffIcon onClick={() => {
                            setPasswordShown(!passwordShown)
                        }} />}
                    </InputAdornment>
                    )
                }}
                onKeyDown={onKeyDown}
            />
        </>
    );
};


